// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lnmGAK {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  width: 100%;
}

.Gf9Nct {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
}

.OfmSmT {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 24px;
  height: 24px;
}

.OfmSmT:hover {
  opacity: 0.8;
}

.lpF05K {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-xl, 24px);
  font-weight: var(--font-weight-semibold, 600);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
}

.mLHYNj {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-stronger, #666666);
  margin: 0;
}

.bcIwiQ {
  width: 8px;
  height: 14px;
  position: relative;
  top: 1px;
  left: 4px;
}

.NYaFFq {
  display: flex;
  flex-direction: column;
  margin-top: var(--spacing-1, 8px);
}

.d4MN1j {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.F89Tz5 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: var(--spacing-1, 8px);
}

.pgBL35 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-size: var(--font-size-md, 14px);
  font-weight: var(--font-weight-regular, 400);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
  margin-bottom: var(--spacing-0-5, 4px);
}

.RQA45e {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.tWD3Yb {
  width: 16px;
  height: 16px;
  accent-color: var(--surface-primary-medium, #d64000);
  cursor: pointer;
  margin: 0;
  border-radius: 50%;
  border-width: 1px;
}

.RvurW6 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: var(--text-neutral-dark, #1f1f1f);
}

.fgfyrR {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  margin-top: var(--spacing-2, 16px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/ResetPassword/components/ChooseMethod/ChooseMethod.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,6CAA6C;EAC7C,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,iEAAiE;EACjE,oCAAoC;EACpC,4CAA4C;EAC5C,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;AACpC","sourcesContent":[".chooseMethodWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n}\n\n.chooseMethodHeader {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n}\n\n.chooseMethodBackButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 24px;\n  height: 24px;\n}\n\n.chooseMethodBackButton:hover {\n  opacity: 0.8;\n}\n\n.chooseMethodTitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-xl, 24px);\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.chooseMethodSubtitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-stronger, #666666);\n  margin: 0;\n}\n\n.chooseMethodBackIcon {\n  width: 8px;\n  height: 14px;\n  position: relative;\n  top: 1px;\n  left: 4px;\n}\n\n.chooseMethodField {\n  display: flex;\n  flex-direction: column;\n  margin-top: var(--spacing-1, 8px);\n}\n\n.chooseMethodInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.chooseMethodRadioGroup {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  margin-top: var(--spacing-1, 8px);\n}\n\n.chooseMethodRadioLabel {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-size: var(--font-size-md, 14px);\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin-bottom: var(--spacing-0-5, 4px);\n}\n\n.chooseMethodRadioOption {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.chooseMethodRadioInput {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--surface-primary-medium, #d64000);\n  cursor: pointer;\n  margin: 0;\n  border-radius: 50%;\n  border-width: 1px;\n}\n\n.chooseMethodRadioText {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  vertical-align: middle;\n  color: var(--text-neutral-dark, #1f1f1f);\n}\n\n.chooseMethodActions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  margin-top: var(--spacing-2, 16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chooseMethodWrapper": `lnmGAK`,
	"chooseMethodHeader": `Gf9Nct`,
	"chooseMethodBackButton": `OfmSmT`,
	"chooseMethodTitle": `lpF05K`,
	"chooseMethodSubtitle": `mLHYNj`,
	"chooseMethodBackIcon": `bcIwiQ`,
	"chooseMethodField": `NYaFFq`,
	"chooseMethodInputWrapper": `d4MN1j`,
	"chooseMethodRadioGroup": `F89Tz5`,
	"chooseMethodRadioLabel": `pgBL35`,
	"chooseMethodRadioOption": `RQA45e`,
	"chooseMethodRadioInput": `tWD3Yb`,
	"chooseMethodRadioText": `RvurW6`,
	"chooseMethodActions": `fgfyrR`
};
module.exports = ___CSS_LOADER_EXPORT___;
